export const scrollTop = (top = 0) => window && window.scroll({
  top,
  left: 0,
  behavior: 'smooth',
})


export const stopPositionFixed = (entry) => {
  if (entry.target.offsetWidth < 900){
    if (entry.isIntersecting) {
      entry.target.firstChild.classList.add('absolute')
    } else {
      entry.target.firstChild.classList.remove('absolute')
    }
  } else {
    entry.target.firstChild.classList.remove('absolute')
  }
}

export const stopControlFixed = (entry) => {
  if (entry.isIntersecting) {
    entry.target.firstChild.classList.remove('fixed')
    entry.target.firstChild.classList.add('static')
  } else {
    entry.target.firstChild.classList.remove('static')
    entry.target.firstChild.classList.add('fixed')
  }
}

export const camelToCapitalCase = (camel) => {
  return camel.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase())
}



// WEBPACK FOOTER //
// ./src/utils/helpers.js